// Generated by Melange


function makeProps(ariaHidden, className, param) {
  return {
    "aria-hidden": ariaHidden,
    className: className
  };
}

export {
  makeProps,
}
/* No side effect */
